// === wizardStepType.js START ====================================================================

wizardSteps["chooseTextTemplate"] = {
    templateName: "#wizardStepChooseTextTemplate",
    onInit: function() {
        Handlebars.registerPartial('chooseTextTemplatesList', $('#wizardStepChooseTextTemplate__templateList').html());
    },
    beforeRender: function (ctx) {
        // This function is called before rendering is done.
        // Model preparation and stuff can be done here.

        ctx.model = {
            templates: []
        };
    },
    afterRender: function (ctx) {
        // Events are bound here
        ApiClient.getTextTemplates()
            .done(function(data) {
                ctx.model.templates = data.data;
                wizardSteps["chooseTextTemplate"].rebuildTextTemplatesList(ctx);

                // Resize the iframe and reposition the modal.
                window.performResize();
                window.PositionModal();
            })
            .fail(function(result) {
                var showData = 'An unknown error occured while loading the text templates.';
                if (result.responseJSON) {
                    if (result.responseJSON.error && result.responseJSON.error.message) {
                        showData = result.responseJSON.error.message;
                    } else if (result.responseJSON.data) {
                        showData = result.responseJSON.data;
                    }
                }
                ShowErrorPanel(showData);
            });
    },
    getButtonList: function () {
        return {
            'back': true
        };
    },
    rebuildTextTemplatesList: function(ctx) {
        var template = Handlebars.partials['chooseTextTemplatesList'];
        var $wrapper = ctx.$el.find('.m-modal__text-templates__list');
        $wrapper.html(template(ctx.model));

        $wrapper.find('.m-modal__text-templates__list__item')
            .on('click',
                function() {
                    var $this = $(this);
                    var templateId = $this.attr('data-id');
                    var template = ctx.model.templates.find(function(t) {
                        return t.id === templateId;
                    });
                    if (template) {
                        currentEvent.databaseTitle = template.templateName;
                        currentEvent.title = template.templateName;
                        if (currentEvent.appointmentType === "Package") {
                            currentEvent.coursePackDescription = template.templateContent;
                        } else {
                            currentEvent.description = template.templateContent;
                        }
                        stepStack.pop(); // current step
                        var prevStep = stepStack.pop(); // The step before
                        if (prevStep) {
                            OpenModal(prevStep);
                        }
                    }
                });
    }
};

// === wizardStepType.js START ====================================================================
